export default __webpack_public_path__ + "static/PEAK_logo-6b3e4b1c2088aa749c426bc0575fad36.png";